export default [
  {
    path: '/app/catalogos/sedes',
    name: 'rt-catalogos-sedes',
    component: () => import('@/views/palmas/catalogos/sede/SedeList.vue'),
    meta: {
      pageTitle: 'Sedes',
      breadcrumb: [
        {
          text: 'Catálogos',
        },
        {
          text: 'Sedes',
          active: true,
        },
      ],
    },
  },
]
